@if (!danger) {
<button
  class="btn btn-primary no-arrow {{ classes }}"
 
  (click)="buttonOnClick()"
  title="{{ label }}"
  [disabled]="disabled"
>
  @if (icon != '') {
<mat-icon
    aria-hidden="false"
    fontIcon="{{ icon }}"
    class="small-icon"
   
  ></mat-icon>
}
  {{ buttonText }}
</button>
}
@if (danger) {
<button
  class="btn btn-danger no-arrow dng-button {{ classes }}"
 
  (click)="buttonOnClick()"
  title="{{ label }}"
  [disabled]="disabled"
>
  @if (icon != '') {
<mat-icon
    aria-hidden="false"
    fontIcon="{{ icon }}"
    class="small-icon"
   
  ></mat-icon>
}
  {{ buttonText }}
</button>
}
